var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:(`
				width: 100%;
				height: ${_vm.height ? (_vm.height < 100 ? 100 : _vm.height) : 100}px;
				display: inline-block;
				position: relative;
			`)},[_c('pre',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":'ace_editor-' + _vm.id}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }